import { SidebarItem } from '@backstage/core-components';
import PeopleIcon from '@material-ui/icons/People';
import { useTeamsAccess } from './TeamsPage';

/** Solo aparece para devops. */
export const TeamsSidebarItem = () => (useTeamsAccess() ? <SidebarItem icon={PeopleIcon} to="teams-roles" text="Equipos y roles" /> : null);
